import React from "react";
import CommonNavbar from "../components/CommonNavbar/CommonNavbar";
import CommonFooter from "../components/CommonFooter/CommonFooter";
import Booking from "../components/Drone/Booking";

const DroneBooking = () => {
  return (
    <div>
      <CommonNavbar hide_btn="d-none" show_btn="d-block" />
      <Booking />
      <CommonFooter />
    </div>
  );
};

export default DroneBooking;
